export default function Icon({ size, color, className = '', children}) {
  return (<span className={`material-symbols-outlined ${className}`}>{children}</span>)
}